module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-dfbba839b96e95492cbdc2acb564542c.webp";